// extracted by mini-css-extract-plugin
export var avatarContainer = "_i7-0";
export var avatarTypingWave = "_i7-i";
export var gray = "_i7-f";
export var green = "_i7-c";
export var icon = "_i7-9";
export var image = "_i7-1";
export var lg = "_i7-6";
export var md = "_i7-5";
export var presenceDot = "_i7-b";
export var red = "_i7-d";
export var sm = "_i7-4";
export var status = "_i7-a";
export var typingDot = "_i7-h";
export var typingPill = "_i7-g";
export var xl = "_i7-7";
export var xs = "_i7-3";
export var xxl = "_i7-8";
export var xxs = "_i7-2";
export var yellow = "_i7-e";